export default {
  'meta': {
    'langName': 'GREEK',
    'lang': 'Ελληνικά'
  },
  'title': 'ΑΝΑΚΛΗΣΗ ΠΡΟΪΟΝΤΟΣ ΜΠΑΣΚΕΤΑ B900 BOX NBA TARMAK',
  'description': 'Έχουμε εντοπίσει τον κίνδυνο πτώσης του στύλου στη μπασκέτα B900, εάν χρησιμοποιηθεί και χειριστεί χωρίς τη λαβή του.\nΓια την ασφάλειά σας, σταματήστε αμέσως κάθε χρήση χωρίς να έχετε τοποθετήσει τη λαβή ρύθμισης ύψους.\nΗ ασφάλιση του προϊόντος σας θα είναι δυνατή με μια απλή διαδικασία και ένα κιτ επισκευής που θα σας παραδοθεί δωρεάν.\nΑυτή η ιστοσελίδα για αυτήν την ανάκληση βρίσκεται υπό κατασκευή. Θα σας καθοδηγήσει στα βήματα για να εκτελέσετε αυτήν τη λειτουργία.\nΘα σας ενημερώσουμε μόλις είναι διαθέσιμη (κατά τη διάρκεια του Ιουλίου).',
  'status': 'Translation validated by COUNTRY'
} as const
